var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("height: " + (_vm.size * 15) + "px;")),attrs:{"data-test-id":"l-space"}})}
var staticRenderFns = []

export { render, staticRenderFns }